import { HiOutlineClock } from 'react-icons/hi2'

export type ContactedWithin7Days = {
  reached: number
  total: number
  percentage: number
}

type Props = {
  data: ContactedWithin7Days
}

export default function ContactedWithin7DaysCard({ data }: Props) {
  const pct = Math.max(0, Math.min(100, data.percentage))

  return (
    <div className="flex flex-col overflow-hidden rounded-xl bg-white shadow-[0px_1px_3px_0px_rgba(0,0,0,0.1),0px_1px_2px_0px_rgba(0,0,0,0.06)]">
      <div className="flex items-center gap-2 border-b border-[#f5f5f5] px-5 py-3">
        <HiOutlineClock className="h-5 w-5 text-ink" aria-hidden="true" />
        <h3 className="font-display text-lg font-medium tracking-tight text-ink">
          Contacted within 7 days
        </h3>
      </div>

      <div className="flex flex-col gap-5 p-6">
        <p className="font-display text-sm text-gray-500">
          {data.reached} of {data.total} leads reached
        </p>
        <p className="font-display text-3xl font-semibold text-gray-900">{pct}%</p>
        <div className="h-2 w-full overflow-hidden rounded-full bg-[#f1f5f9]">
          <div
            className="h-2 rounded-full bg-[#93D500] transition-all"
            style={{ width: `${pct}%` }}
          />
        </div>
      </div>
    </div>
  )
}
